export const API_CONFIG = {
	ROUTE: '/api',
	ACCESSOIRES: '/accessory',
	ATEX: '/atex',
	ATEX_ALL: '/atex/all',
	SEARCH_ATEX: '/atex/search',
	AUTH: '/auth',
	DOCUMENT: '/document',
	SEARCH_DOCUMENT: '/document/search',
	FAQ: '/faqCategory',
	FAQ_ITEM: '/faq',
	FAQ_ALL: '/faqCategory/all',
	LANGUAGE: '/language',
	PARTNER: '/partner',
	PRODUCT: '/product',
	PRODUCT_ALL: '/product/all',
	PRODUCT_BY_CATEGORY: '/product/byCategory',
	PRODUCT_CATEGORY: '/productCategory',
	PRODUCT_CATEGORY_ALL: '/productCategory/all',
	SEARCH_PRODUCT_CATEGORY: '',
	PRODUCT_TYPE: '/productType',
	PROJECT: '/project',
	POJECT_ALL: '/project/all',
	SEARCH_PROJECT: '/project/search',
	REFERENCE: '/reference',
	TESTIMONIES: '/quote',
	FILE: '/file',
	USER: '/user',
	CONTACT: '/contact',
	IMAGE: '/file/image',
	TRANSLATION: '/file/translation',
};



// WEBPACK FOOTER //
// ./src/config/api.config.js